/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_Li1_PostInputs */

const tr_iade_iptal_s11_li1_post = /** @type {(inputs: Iade_Iptal_S11_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` adresindedir. Bu döküm, siparişlerin JSON, CSV veya PDF olarak dışa aktarılması değildir.`)
};

const en_iade_iptal_s11_li1_post = /** @type {(inputs: Iade_Iptal_S11_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. This statement is not an export of orders in JSON, CSV or PDF.`)
};

const de_iade_iptal_s11_li1_post = /** @type {(inputs: Iade_Iptal_S11_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` erreichbar. Dieser Auszug ist kein Export von Bestellungen als JSON, CSV oder PDF.`)
};

const ru_iade_iptal_s11_li1_post = /** @type {(inputs: Iade_Iptal_S11_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Эта выписка не является экспортом заказов в JSON, CSV или PDF.`)
};

/**
* | output |
* | --- |
* | ". This statement is not an export of orders in JSON, CSV or PDF." |
*
* @param {Iade_Iptal_S11_Li1_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_li1_post = /** @type {((inputs?: Iade_Iptal_S11_Li1_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_Li1_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_li1_post(inputs)
	if (locale === "de") return de_iade_iptal_s11_li1_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_li1_post(inputs)
	return tr_iade_iptal_s11_li1_post(inputs)
});